/*
 * @Author: junjie.lean
 * @Date: 2019-04-16 12:59:32
 * @Last Modified by: xiangr
 * @Last Modified time: 2021-10-26 18:54:14
 */

/**
 * @description 整理之前的_x通用工具集,并对部分方法重新封装。
 */

import _ from 'lodash'
import { Modal } from 'ant-design-vue'
import { uploadFileType } from '@/view/public/uploadFileType'
import { readLocal } from '@/view/public/common'
import { onJumpLink } from '@/utils/toAndroid'
import { colors } from 'nightwatch/lib/util/logger'

/************************************ 目录 ************************************/
/**
 * setSS ----------- 在sessionStorage中存一个加密过后的值
 * getSS ----------- 从sessionStorage中取一个值，并且解密
 * getQueryString ----------- 从URL中获取指定参数
 * goWith ----------- 新开新标签页面的跳转方法
 * toChinese ----------- 将数字转换成中文文本
 * formatSize ----------- 格式化字节大小字符串
 * Number.prototype.formatSize ----------- 同上
 * getWeekFromYear ----------- 获取从某一年开始计算到指定日期值的周数
 * getWeekFromMonth ----------- 获取指定日期在本月的周数
 * getWeekStart ----------- 获取指定时间所在周的第一天日期
 * getMonthDays ----------- 获取指定时间所在月的天数
 * formatSec ----------- 格式化秒数
 * formatMin ----------- 秒数转化成分钟
 * timeLength ----------- 计算时间长度
 * typeCheck ----------- 变量类型检测
 * .......
 */
/************************************ 目录结束 ************************************/

/************************************ 缓存相关 ************************************/

/************************************ URL相关 ************************************/

/**
 *
 * @param { String } name
 * @scene browser
 * @description 从URL中获取指定参数
 * @returns 指定参数
 */
const getQueryString = name => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let w = window.location.href.slice(window.location.href.indexOf('?'))
  let r = w.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export function GetUrlParam(paraName) {
  var url = document.location.toString()
  var arrObj = url.split('?')
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&')
    var arr
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')

      if (arr != null && arr[0] == paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

function getRequest() {
  var url = window.location.search //获取url中"?"符后的字串
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var str = url.substr(1)
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
    }
  }
  return theRequest
}

/**
 *
 * @param { Object } pr
 * @scene browser
 * @description 新开新标签页面的跳转方法
 * @returns false
 */
const goWith = (pr = { to: 'index', with: [] }) => {
  let url = window.location.href
  let href = url.slice(0, url.indexOf('#') + 2)
  // console.log(href);
  href += pr.to + '/' + pr.with.join('/')
  window.open(href)
  return false
}

/************************************ 数字类型 ************************************/

/**
 * @param   {Number} number      需要转换的数字
 * @param   {Boolean} bIsCapital 是否中文大写
 * @description 将数字转换成中文文本
 * @returns {String}  转换后的字符串
 */
const toChinese = (number, bIsCapital) => {
  let str = number + ''
  let len = str.length - 1
  let idxs = [
    '',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿'
  ]
  let num
  if (bIsCapital) {
    num = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  } else {
    num = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  }
  return str.replace(/([1-9]|0+)/g, function ($, $1, idx, full) {
    let pos = 0
    if ($1[0] !== '0') {
      pos = len - idx
      if (idx == 0 && $1[0] == 1 && idxs[pos] == '十') {
        return idxs[pos]
      }
      return num[$1[0]] + idxs[pos]
    } else {
      let left = len - idx
      let right = left + $1.length
      if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
        pos = left - (left % 4)
      }
      if (pos) {
        return idxs[pos] + num[$1[0]]
      } else if (idx + $1.length >= len) {
        return ''
      } else {
        return num[$1[0]]
      }
    }
  })
}

/**
 * @param   {Number} number    需要转换的数字
 * @param   {Boolean} baseUnit 基准单位，默认为K
 * @description 格式化字节大小字符串（精确到小数点后两位）
 * @returns {String}  转换后的字符串
 */
const formatSize = (number, baseUnit) => {
  baseUnit = baseUnit || ''
  baseUnit = baseUnit.toUpperCase()
  let units = ['', 'K', 'M', 'G', 'T'],
    cnt = 0,
    size = number,
    index = 0
  while (size > 1024) {
    size = size / 1024
    cnt++
  }
  units.forEach((item, idx) => {
    if (item === baseUnit) {
      index = idx
    }
  })
  return size.toFixed(2) + units[index + cnt] + 'B'
}

/**
 * @param { String } baseUnit 基准单位，默认为K
 * @description 文件大小转换 数字类型原型方法
 */
Number.prototype.formatSize = baseUnit => {
  baseUnit = baseUnit || 'K'
  baseUnit = baseUnit.toUpperCase()
  let units = ['K', 'M', 'G', 'T'],
    cnt = 0,
    size = this,
    index = 0
  while (size > 1024) {
    size = size / 1024
    cnt++
  }
  units.forEach(function (item, idx) {
    if (item === baseUnit) {
      index = idx
    }
  })
  return size.toFixed(1) + units[index + cnt] + 'B'
}

/************************************ Date类型 ************************************/

/**
 * @param   {Date} date         指定日期
 * @param   {Number} nYear      开始计算的年份，默认为当前日期值所在年份
 * @param   {Number} nWeekStart 每周开始为周几，默认为周一
 * @returns {Number} 总周数
 * @description 获取从某一年开始计算到指定日期值的周数
 */
const getWeekFromYear = (date, nYear, nWeekStart) => {
  nWeekStart = (nWeekStart || 1) - 0
  if (isNaN(nWeekStart) || nWeekStart > 6) nWeekStart = 1
  if (!nYear) {
    nYear = date.getFullYear()
  }
  let dFirstDay = new Date(nYear, 0, 1)
  let nFirstWeekDays = 7 - dFirstDay.getDay() + nWeekStart
  let nDayOfYear =
    (new Date(date.getFullYear(), date.getMonth(), date.getDate()) - dFirstDay) /
      (24 * 3600 * 1000) +
    1
  return Math.ceil((nDayOfYear - nFirstWeekDays) / 7) + 1
}

/**
 *
 * @param   {Date} date         指定日期
 * @param   {Number} nWeekStart 每周开始为周几，默认为周一, 可选值1到7
 * @returns {Number} 总周数
 * @description 获取指定日期在本月的周数
 */
const getWeekFromMonth = (date, nWeekStart) => {
  nWeekStart = (nWeekStart || 1) % 7
  if (isNaN(nWeekStart) || nWeekStart > 7) nWeekStart = 1
  let dFirstDay = new Date(date.getFullYear(), date.getMonth(), 1)
  let nFirstWeekDays = 7 - dFirstDay.getDay() + nWeekStart
  let nDayOfYear =
    (new Date(date.getFullYear(), date.getMonth(), date.getDate()) - dFirstDay) /
      (24 * 3600 * 1000) +
    1
  return Math.ceil((nDayOfYear - nFirstWeekDays) / 7) + 1
}

/**
 * @param   {Date} date         指定日期
 * @param   {Number} nWeekStart 每周开始为周几，默认为周一, 可选值1到7
 * @returns {Date}
 * @description 获取指定时间所在周的第一天日期
 */
const getWeekStart = (date, nWeekStart) => {
  nWeekStart = (nWeekStart || 1) % 7
  if (isNaN(nWeekStart) || nWeekStart > 7) nWeekStart = 1
  let ndate = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  ndate.setDate(date.getDate() - date.getDay() + nWeekStart)
  return ndate
}

/**
 * @param   {Date} date         指定日期
 * @returns {Number}
 * @description 获取指定时间所在月的天数
 */
const getMonthDays = date => {
  let d = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return d.getDate()
}

/**
 *
 * @param {Number} sec
 * @description 格式化秒数
 */
const formatSec = sec => {
  let time
  if (!sec) {
    time = "00'" + '00"'
  } else if (sec < 10) {
    time = "00'0" + sec + '"'
  } else if (sec >= 10 && sec < 60) {
    time = "00'" + sec + '"'
  } else {
    let rem = sec / 60
    if (Math.floor(rem) !== rem) {
      rem = sec - parseInt(sec / 60) * 60
      if (rem < 10) {
        time = parseInt(sec / 60) + "'0" + rem + '"'
      } else {
        time = parseInt(sec / 60) + "'" + rem + '"'
      }
    } else {
      time = parseInt(sec / 60) + "'" + '00"'
    }
  }
  return time
}

/**
 * @param {Number} sec
 * @description 秒数转化成分钟
 */
const formatMin = sec => {
  let time
  if (sec && sec < 60) {
    time = 1
  } else {
    let rem = sec / 60
    if (Math.floor(rem) !== rem) {
      time = parseInt(rem) + 1
    } else {
      time = parseInt(rem)
    }
  }
  return time
}

/**
 *
 * @param {String} 开始时间 09:12:00
 * @param {String} 结束时间
 * @description 计算时间长度
 */
const timeLength = (start, end) => {
  let starts = start.split(':')
  let ends = end.split(':')
  let startLong =
    Number(starts[0]) * 60 * 60 * 1000 + Number(starts[1]) * 60 * 1000 + Number(starts[2]) * 1000
  let endLong =
    Number(ends[0]) * 60 * 60 * 1000 + Number(ends[1]) * 60 * 1000 + Number(ends[2]) * 1000
  let result = endLong - startLong
  return result > 0 ? result : 0
}

/************************************ 其他功能 ************************************/

/**
 *
 * @param {*} val  任意类型的变量
 * @description 变量类型检测
 * @returns 返回类型
 */
const typeCheck = val => {
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase()
}
const getCookie = name => {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) return unescape(arr[2])
  else return null
}

export const throttling = (fn, wait, immediate) => {
  let timer,
    timeStamp = 0
  let context, args

  let run = () => {
    timer = setTimeout(() => {
      if (!immediate) {
        fn.apply(context, args)
      }
      clearTimeout(timer)
      timer = null
    }, wait)
  }

  return function () {
    context = this
    args = arguments
    if (!timer) {
      // console.log("throttle, set");
      if (immediate) {
        fn.apply(context, args)
      }
      run()
    } else {
      // console.log("throttle, ignore");
    }
  }
}

//时间戳转换方法
export const formatDate = date => {
  var date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return YY + MM + DD + ' ' + hh + mm + ss
}

/**
 * @description: 把字节转换成正常文件大小
 * @param {*} size
 * @return {*}
 */
const getFileSize = size => {
  if (!size) return '--'
  let num = 1024.0 //byte
  if (size < num) return size + 'B'
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + 'KB' //kb
  if (size < Math.pow(num, 3)) return (size / Math.pow(num, 2)).toFixed(2) + 'MB' //M
  if (size < Math.pow(num, 4)) return (size / Math.pow(num, 3)).toFixed(2) + 'G' //G
  return (size / Math.pow(num, 4)).toFixed(2) + 'T' //T
}

/**
 * @description: 防抖
 * @param func
 * @param delay
 * @returns {(function(): void)|*}
 */
const debounce = (func, delay) => {
  let timer = null
  return function () {
    const context = this // 记录 this 值,防止在回调函数中丢失
    const args = arguments // 函数参数
    const isImmediately = !timer // 标识是否立即执行
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
    }, delay)
    // isImmediately 为 true 则 执行函数(即首次触发事件)
    // eslint-disable-next-line no-unused-expressions
    isImmediately ? func.apply(context, args) : null
  }
}

/**
 * @description 函数节流
 * @param func 回调函数
 * @param limit 时间限制
 */
const throttle = (func, limit) => {
  // 上次执行时间
  let previous = 0
  return function () {
    const now = Date.now()
    const context = this
    // 若当前时间-上次执行时间大于时间限制
    if (now - previous > limit) {
      func.apply(context, arguments)
      previous = now
    }
  }
}

// 随机生成uuid
const uuid = (len, radix) => {
  let chars = '0123456789abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz'.split('')
  let uuid = []
  let i
  radix = radix || chars.length
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

/**
 * @description: 判断两个对象值是否相等
 * @param {Object} objA
 * @param {Object} objB
 * @return {Boolean}
 */
const isEquals = (objA, objB) => {
  if (!objA || !objB) return true // 传入的参数为空时，返回true
  const keysA = Object.keys(objA)
  const keysB = Object.keys(objB)
  if (keysA.length !== keysB.length) return false // 比较两个对象的键数量
  for (let key of keysA) {
    // 忽略空字符串、null 和 undefined 的属性
    if (objA[key] === '' || objA[key] === null || objA[key] === undefined) {
      if (objB[key] !== '' || objB[key] !== null || objB[key] !== undefined) {
        return true
      }
    } else if (typeof objA[key] === 'object') {
      // 递归比较对象属性值
      if (!isEquals(objA[key], objB[key])) {
        return false
      }
    } else if (objA[key] !== objB[key]) {
      // 比较基本类型的属性值
      return false
    }
  }
  return true
}

/**
 * @description 处理文件图标
 * @param fileName 文件名
 * @returns {string}
 */
const handelAppendixIcon = fileName => {
  if (!fileName) return ''
  const fileIndex = fileName.lastIndexOf('.')
  const fileType = fileName.substring(fileIndex).toLowerCase()
  if (uploadFileType.doc.includes(fileType)) {
    return 'word'
  } else if (uploadFileType.excel.includes(fileType)) {
    return 'excel'
  } else if (uploadFileType.pdf.includes(fileType)) {
    return 'pdf'
  } else if (uploadFileType.ppt.includes(fileType)) {
    return 'ppt'
  } else if (uploadFileType.txt.includes(fileType)) {
    return 'txt'
  } else if (uploadFileType.image.type.includes(fileType)) {
    return 'img'
  } else if (uploadFileType.zip.type.includes(fileType)) {
    return 'zip'
  } else if (uploadFileType.audio.type.includes(fileType)) {
    return 'audio'
  } else if (uploadFileType.video.type.includes(fileType)) {
    return 'video'
  } else if (uploadFileType.other.type.includes(fileType)) {
    return 'dbf'
  } else {
    return 'file_deauflt'
  }
}

// js的base32、base64编码方法实现
const Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: function (e) {
    let t = ''
    let n, r, i, s, o, u, a
    let f = 0
    e = Base64._utf8_encode(e)
    while (f < e.length) {
      n = e.charCodeAt(f++)
      r = e.charCodeAt(f++)
      i = e.charCodeAt(f++)
      s = n >> 2
      o = ((n & 3) << 4) | (r >> 4)
      u = ((r & 15) << 2) | (i >> 6)
      a = i & 63
      if (isNaN(r)) {
        u = a = 64
      } else if (isNaN(i)) {
        a = 64
      }
      t =
        t +
        this._keyStr.charAt(s) +
        this._keyStr.charAt(o) +
        this._keyStr.charAt(u) +
        this._keyStr.charAt(a)
    }
    return t
  },
  decode: function (e) {
    let t = ''
    let n, r, i
    let s, o, u, a
    let f = 0
    e = e.replace(/[^A-Za-z0-9+/=]/g, '')
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++))
      o = this._keyStr.indexOf(e.charAt(f++))
      u = this._keyStr.indexOf(e.charAt(f++))
      a = this._keyStr.indexOf(e.charAt(f++))
      n = (s << 2) | (o >> 4)
      r = ((o & 15) << 4) | (u >> 2)
      i = ((u & 3) << 6) | a
      t = t + String.fromCharCode(n)
      if (u != 64) {
        t = t + String.fromCharCode(r)
      }
      if (a != 64) {
        t = t + String.fromCharCode(i)
      }
    }
    t = Base64._utf8_decode(t)
    return t
  },
  _utf8_encode: function (e) {
    e = e.replace(/rn/g, 'n')
    let t = ''
    for (let n = 0; n < e.length; n++) {
      let r = e.charCodeAt(n)
      if (r < 128) {
        t += String.fromCharCode(r)
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192)
        t += String.fromCharCode((r & 63) | 128)
      } else {
        t += String.fromCharCode((r >> 12) | 224)
        t += String.fromCharCode(((r >> 6) & 63) | 128)
        t += String.fromCharCode((r & 63) | 128)
      }
    }
    return t
  },
  _utf8_decode: function (e) {
    let c1
    let c2
    let c3
    let t = ''
    let n = 0
    let r = (c1 = c2 = 0)
    while (n < e.length) {
      r = e.charCodeAt(n)
      if (r < 128) {
        t += String.fromCharCode(r)
        n++
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1)
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63))
        n += 2
      } else {
        c2 = e.charCodeAt(n + 1)

        c3 = e.charCodeAt(n + 2)
        t += String.fromCharCode(((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        n += 3
      }
    }
    return t
  }
}

// 判断富文本字符串只包含标签
function isRichTextOnlyTags(richText) {
  // 创建一个虚拟DOM元素
  const tempElement = document.createElement('div')
  tempElement.innerHTML = richText
  // 获取所有子元素
  const childNodes = tempElement.childNodes
  // 检查是否只有一个子元素，并且这个子元素是 <p> 标签
  if (childNodes.length === 1 && childNodes[0].nodeName === 'P') {
    const pContent = childNodes[0].innerHTML
    // 检查 <p> 标签的内容是否是一个 <br> 标签
    return pContent.trim().toLowerCase() === '<br>'
  }
  return false
}

// 对象转query字符串的方法
function objToQuery(obj) {
  if (obj) {
    let query = ''
    for (let i in obj) {
      let value = obj[i]
      if (Array.isArray(value)) {
        value = value.join(',')
      }
      query += `&${i}=${value}`
    }
    query = query.replace('&', '?')
    return query
  }
  return ''
}

/**
 * @description 文件流对象转为url地址下载文件
 * @param stream {blob} 文件流对象
 * @param fileName {string} 文件名
 */
function downloadFileFromStream(stream, fileName) {
  const dataURI = 'data:application/octet-stream;base64,' + btoa(stream)
  const a = document.createElement('a')
  a.href = dataURI
  a.download = fileName || 'download'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * 解析HTML字符串，添加自定义点击事件并插入到指定容器
 * @param {string} html - HTML字符串
 * @param {string} containerId - 容器的ID
 * @param {fn} callback - 点击事件回调函数
 */
function parseAndAttachEvents(html, containerId, callback) {
  const parser = new DOMParser() // 使用 DOMParser 替代直接设置 innerHTML 来避免 XSS 攻击
  const doc = parser.parseFromString(html, 'text/html')

  // 获取临时容器中的 <a> 标签
  let links = doc.body.getElementsByTagName('a')

  // 为每个 <a> 标签添加自定义点击事件
  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (event) {
      event.preventDefault() // 阻止默认行为
      const { textContent, href } = event.target
      let link_url = href || textContent
      // 如果href不存在，则找父节点的href
      if (!href) {
        link_url = event.target.parentNode.href
      }

      if (callback) {
        callback(textContent, link_url) // 调用回调函数
      } else {
        const linkStyle = {
          color: '#4d7cfe',
          'border-bottom': '1px solid'
        }
        const iconStyles = {
          color: '#4d7cfe',
          'vertical-align': '1px',
          'margin-right': '4px'
        }

        /* 二次弹框确认跳转 */
        Modal.confirm({
          title: h => <div class="fs16 fw700">即将跳转至外部链接</div>,
          okText: '继续访问',
          centered: true,
          content: h => (
            <div class="text-justified">
              <p style="color:#AAAEB2" class="mb8 fs14">
                请保护好个人信息
              </p>
              <a-icon type="link" style={iconStyles} />
              <span style={linkStyle}>{textContent}</span>
            </div>
          ),
          onOk() {
            const clientType = readLocal('client')
            onJumpLink(clientType, link_url)
          }
        })
      }
    })
  }

  // 获取目标容器
  let container = document.getElementById(containerId)
  if (container) {
    container.innerHTML = '' // 清空容器
    container.appendChild(doc.body) // 插入修改后的内容
  } else {
    console.error(`容器ID "${containerId}" 不存在。`)
  }
}

/**
 * @description 截取富文本内容限制在指定字数
 * @param htmlContent {string} html文本
 * @param maxLength {number} 最大字数
 * @return {*|string}
 */
function truncateRichTextContent(htmlContent, maxLength) {
  const tempElement = document.createElement('div')
  tempElement.innerHTML = htmlContent

  let charCount = 0
  let reachedLimit = false

  function truncateNode(node) {
    if (reachedLimit) return null

    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent
      const remainingChars = maxLength - charCount

      if (charCount + textContent.length > maxLength) {
        const truncatedText = textContent.substring(0, remainingChars)
        charCount += remainingChars
        reachedLimit = true
        return document.createTextNode(truncatedText)
      } else {
        charCount += textContent.length
        return node.cloneNode(true)
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const clone = node.cloneNode(false) // 仅克隆节点本身，不克隆子节点

      for (let i = 0; i < node.childNodes.length; i++) {
        const childNode = truncateNode(node.childNodes[i])
        if (childNode) {
          clone.appendChild(childNode)
        }
        if (reachedLimit) break
      }

      return clone
    }
    return null
  }

  const truncatedElement = truncateNode(tempElement)

  return truncatedElement ? truncatedElement.innerHTML : ''
}

/**
 * @description 计算富文本内容长度
 * @param htmlContent {string} html文本
 * @return {number} 字数
 */
function getRichTextContentLength(htmlContent) {
  const tempElement = document.createElement('div')
  tempElement.innerHTML = htmlContent

  let totalLength = 0

  function traverseNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      totalLength += node.textContent.length
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (let i = 0; i < node.childNodes.length; i++) {
        traverseNodes(node.childNodes[i])
      }
    }
  }

  traverseNodes(tempElement)

  return totalLength
}

// 判断值所有为空的情况
function isAllEmpty(value) {
  if (Array.isArray(value)) {
    return value.every(isAllEmpty)
  } else if (typeof value === 'object' && value !== null) {
    return Object.values(value).every(isAllEmpty)
  }

  return (
    value === null ||
    value === undefined ||
    value === '' ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  )
}

// 是否支持分卷格式
function checkCompressionFormat(filename) {
  const result = {
    isSupported: false, // 是否支持此分卷格式
    type: null, // 压缩类型: 'rar' | 'zip' | '7z'
    isVolume: false, // 是否是分卷文件
    volumeNum: null, // 分卷编号（如果是分卷）
    isMain: false // 是否是主文件（非分卷）
  }

  const lowerName = filename.toLowerCase()
  const parts = lowerName.split('.') // 按点分割文件名

  // 优先检查分卷格式，再检查主文件
  const checkRar = () => {
    // 匹配 .partX.rar 或 .rXX
    const isPartVolume =
      parts.length >= 3 &&
      parts[parts.length - 1] === 'rar' &&
      /^part\d+$/.test(parts[parts.length - 2])
    const isRxxVolume = parts.length >= 2 && /^r\d{2}$/.test(parts[parts.length - 1])

    if (isPartVolume) {
      result.type = 'rar'
      result.isVolume = true
      result.volumeNum = parseInt(parts[parts.length - 2].replace('part', ''), 10)
    } else if (isRxxVolume) {
      result.type = 'rar'
      result.isVolume = true
      result.volumeNum = parseInt(parts[parts.length - 1].replace('r', ''), 10)
    } else if (parts[parts.length - 1] === 'rar') {
      result.type = 'rar'
      result.isMain = true
    }
  }

  const checkZip = () => {
    const zipReg =
      /^.*\.(?:[zZ][iI][pP]|[zZ]\d{2}|[zZ][iI][pP]\.\d{3}|[pP][aA][rR][tT]\d+\.[zZ][iI][pP])$/
    if (zipReg.test(filename)) {
      result.type = 'zip'
      result.isMain = true
    }
  }

  const check7z = () => {
    // 匹配 .7z.XXX 或主文件 .7z
    const is7zVolume =
      parts.length >= 3 &&
      parts[parts.length - 2] === '7z' &&
      /^\d{3}$/.test(parts[parts.length - 1])
    if (is7zVolume) {
      result.type = '7z'
      result.isVolume = true
      result.volumeNum = parseInt(parts[parts.length - 1], 10)
    } else if (parts[parts.length - 1] === '7z') {
      result.type = '7z'
      result.isMain = true
    }
  }

  // 按优先级检查（RAR → ZIP → 7z）
  checkRar()
  if (!result.type) checkZip()
  if (!result.type) check7z()

  // 最终结果
  result.isSupported = !!result.type
  return result
}

/**
 * 从 Content-Disposition 头部提取文件名
 * @param {string} contentDisposition - Content-Disposition 头部的值
 * @returns {string|null} - 解析出的文件名，失败则返回 null
 */
function extractFilenameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null

  const filenameRegex = /filename\*?=(?:UTF-8''|['"])?([^;\n]*)/i
  const matches = filenameRegex.exec(contentDisposition)

  if (matches && matches[1]) {
    let filename = matches[1]

    // 去除可能存在的引号
    filename = filename.replace(/['"]/g, '')

    // 尝试解码（无论是否有编码都尝试解码）
    try {
      // 如果包含%但不以UTF-8''开头，直接解码整个字符串
      if (filename.includes('%') && !filename.toLowerCase().startsWith("utf-8''")) {
        filename = decodeURIComponent(filename)
      }
      // 如果是RFC 5987格式（UTF-8''开头）
      else if (filename.toLowerCase().startsWith("utf-8''")) {
        filename = decodeURIComponent(filename.substring(7))
      }
    } catch (e) {
      // 解码失败则保持原样
      console.warn('Filename decode failed:', e)
    }

    return filename || null
  }

  return null
}

/**
 * 数字格式化 每三位逗号隔开
 * @param {*} num
 */
const thousands = num => {
  if (num) {
    var str = num.toString()
    var reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g
    return str.replace(reg, '$1,')
  } else {
    return '0'
  }
}

export default {
  getQueryString,
  GetUrlParam,
  goWith,
  toChinese,
  formatSize,
  timeLength,
  formatMin,
  formatSec,
  getWeekFromMonth,
  getMonthDays,
  getWeekStart,
  getWeekFromYear,
  typeCheck,
  getCookie,
  getFileSize,
  debounce,
  throttle,
  uuid,
  isEquals,
  handelAppendixIcon,
  Base64,
  isRichTextOnlyTags,
  objToQuery,
  downloadFileFromStream,
  parseAndAttachEvents,
  truncateRichTextContent,
  getRichTextContentLength,
  isAllEmpty,
  checkCompressionFormat,
  extractFilenameFromContentDisposition,
  thousands
}



// WEBPACK FOOTER //
// ./src/utils/_util.js